module.exports = __webpack_public_path__ + "img/station.238d5580.png";